export default __webpack_public_path__ + "static/media/live_preparing.6235249f.png";